//@ts-nocheck
import React, { useEffect, useState } from "react";
import { IWidgetModel } from "widget-models/lib";
import { ISegmentDetails } from "widget-models/lib/models/STW/stw.interface";
import {
  addDiscountText,
  getSegmentDetails,
  updateSegmentWidth,
  getContrastColor,
  generateRotationValues,
} from "../utility";
import "./Wheel.css";
import { pageVisitedSTW, startGameSTW, endGameSTW } from "../../apis";
import { useHistory } from "react-router-dom";

export interface IWheel extends IWidgetModel {
  onCloseHandle?: (
    component: "wheel" | "userDetails" | "couponDetails"
  ) => void;
}
const Wheel = (props: any) => {
  const { widgetCustomisation } = props;
  const {
    couponFont,
    spinnerColor,
    spikesCount,
    segmentColor1,
    segmentColor2,
    discountCodeTitle,
  } = widgetCustomisation as any;

  const [segmentWidth, setSegmentWidth] = useState<number>(null);
  const [segmentDetailsFinal, setSegmentDetailsFinal] = useState<
    ISegmentDetails[]
  >([]);
  const [segmentDividerAngle, setSegmentDividerAngle] = useState<number>(null);
  const [couponDetails, setCouponDetails] = useState();
  const [rotationValues, setRotationValues] = useState<[]>([]);

  const history = useHistory();

  const getPathName = () => {
    return window.location?.pathname + window.location?.search;
  };

  const pathname = getPathName();
  useEffect(() => {
    pageVisitedSTW(pathname).then((data) => {
      if (data.status === 200) {
        setCouponDetails(data.couponDetails);
      }
    });
  }, []);

  useEffect(() => {
    const rotationValuesTemp = generateRotationValues(spikesCount) as [];
    setRotationValues(rotationValuesTemp);
    setSegmentDividerAngle(90 - 360 / (spikesCount * 2));
    setSegmentWidth(updateSegmentWidth(spikesCount));
    setSegmentDetailsFinal(
      getSegmentDetails(
        spikesCount,
        segmentColor1,
        segmentColor2,
        discountCodeTitle
      )
    );
  }, [spikesCount, segmentColor1, segmentColor2]);

  useEffect(() => {
    if (
      discountCodeTitle &&
      Object.keys(discountCodeTitle)?.length &&
      segmentDetailsFinal?.length
    ) {
      setSegmentDetailsFinal(
        addDiscountText(discountCodeTitle, segmentDetailsFinal)
      );
    }
  }, [discountCodeTitle]);

  const onSpinHandle = () => {
    startGameSTW(pathname);
    let container = document.getElementsByClassName("bikContainerSpinner")[0];
    let number = 360 * 7;
    container.style.transitionDuration = "5s";
    container.style.transform = "rotate(" + number + "deg)";
    processRotationValueSTW1(container, couponDetails.couponType);
  };

  const processRotationValueSTW1 = (container, winningSector) => {
    let finalSectorTemp = winningSector;
    let random = null;
    let number = 360 * 7;
    if (finalSectorTemp === 1) {
      random =
        360 -
        Math.floor(
          Math.random() *
            (rotationValues[winningSector].maxDegree -
              rotationValues[winningSector].minDegree +
              1)
        );
    } else if (finalSectorTemp > 1 && finalSectorTemp <= spikesCount / 2 + 1) {
      random =
        360 -
        rotationValues[winningSector].minDegree -
        Math.floor(
          Math.random() *
            (rotationValues[winningSector].maxDegree -
              rotationValues[winningSector].minDegree +
              1)
        );
    } else {
      random =
        Math.floor(
          Math.random() *
            (rotationValues[winningSector].maxDegree -
              rotationValues[winningSector].minDegree +
              1)
        ) + Math.abs(360 - rotationValues[winningSector].maxDegree);
    }
    number = random + number;
    container.style.transform = "rotate(" + number + "deg)";
    valueGenerator();
  };

  const setAuthValue = () => {
    localStorage.setItem("isAuthenticated", JSON.stringify(true));
  };

  const valueGenerator = () => {
    setTimeout(() => {
      endGameSTW(pathname);
      setAuthValue();
      history.push({
        pathname: "/shoppers-stop/userDetails",
        state: { couponId: couponDetails.couponId, utm: pathname },
      });
    }, 6000);
  };

  return (
    <>
      <div className="bikMainContainer">
        <div className="bikContainerSpinner">
          <div className="bikContainerInner" style={{ fontFamily: couponFont }}>
            <div className="bikContainerOverlay"></div>
            {segmentDetailsFinal.map((details) => {
              return (
                <div
                  key={JSON.stringify(details)}
                  className={`bikSegment ${details.class}`}
                  style={{
                    backgroundColor: details.color,
                    transform: `rotate(${details.rotationValue}deg)`,
                    width: `${segmentWidth}px`,
                    color: getContrastColor(details.color),
                  }}
                >
                  <span className="bikCouponText">{details.text}</span>
                  <span
                    id="testing"
                    className="bikSegmentDivider"
                    style={{ transform: `rotate(-${segmentDividerAngle}deg)` }}
                  ></span>
                </div>
              );
            })}
          </div>
        </div>
        <div className="bikContainerSpin" onClick={onSpinHandle}>
          <div className="bikSpinArrow"></div>
          <div
            id="spin"
            className="bikSpinContent"
            style={{ backgroundColor: spinnerColor }}
          >
            <div className="bikSpinLogo">SPIN</div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Wheel;
